// src/components/home/BuildInPublic.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCompass, FaRocket, FaTools } from "react-icons/fa";
import "./BuildInPublic.css";

const BuildInPublic = () => {
  const navigate = useNavigate();

  return (
    <section className="bvh-build-public-section" data-aos="fade-up">
      <div className="bvh-build-public-card">
        <div className="bvh-build-public-header">
          <span className="bvh-build-public-tag">
            <FaTools /> Building in Public
          </span>
          <h2 className="bvh-build-public-title">Open Product Development</h2>
        </div>

        <div className="bvh-build-public-grid">
          <div className="bvh-build-grid-item">
            <h4>What I'm Building</h4>
            <p>BodhAI — AI-powered examination & learning portal.</p>
          </div>
          <div className="bvh-build-grid-item">
            <h4>Who It's For</h4>
            <p>Students, developers, and teachers worldwide.</p>
          </div>
          <div className="bvh-build-grid-item">
            <h4>Hardest Part</h4>
            <p>Growing organically & refining compiler reliability as a creator.</p>
          </div>
          <div className="bvh-build-grid-item">
            <h4>Status</h4>
            <p>100% Free to Try • V2 Beta Live on Product Hunt</p>
          </div>
        </div>

        <div className="bvh-build-public-actions">
          <button
            className="bvh-build-btn primary"
            onClick={() => navigate("/our-journey")}
          >
            <FaCompass /> Follow Journey →
          </button>
          <a
            href="https://betav2.bodhai.pages.dev/"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-build-btn secondary"
          >
            <FaRocket /> Try Beta
          </a>
        </div>
      </div>
    </section>
  );
};

export default React.memo(BuildInPublic);
